<template>
  <div class="container-custom">
    <Breadscrumbs
      :links="[
        { name: 'Alert Info', to: { path: '/alert-info' } },
        { name: 'Edit', to: { path: '/alert-info/edit' } },
      ]"
    ></Breadscrumbs>
    <div class="page-actions">
      <h2>編輯Alert Info</h2>
      <v-spacer></v-spacer>
      <button class="btn mr-5" @click="cancelHandler">
        取消
      </button>
      <button class="btn btn-primary" @click="saveHandler">儲存</button>
    </div>
    <div class="block">
      <!-- Title -->
      <div class="form-item py-5 d-flex">
        <div class="w-240px mr-5">
          <h4>Title</h4>
        </div>
        <div class="flex-grow-1 flex-basis-0 my-n2">
          <div class="form-input-group">
            <input type="text" />
          </div>
          <div class="h5 mt-1 ink-02-medium--text text-right">4/20</div>
        </div>
      </div>
      <!-- Content -->
      <div class="form-item py-5 d-flex">
        <div class="w-240px mr-5">
          <h4>Content</h4>
        </div>
        <div class="flex-grow-1 flex-basis-0 my-n2">
          <TextEditor></TextEditor>
        </div>
      </div>
      <!-- 設定開始日期 -->
      <div class="form-item py-5 d-flex">
        <div class="w-240px mr-5">
          <h4>設定開始日期</h4>
          <div class="mt-3 h5 ink-02-medium--text">
            前台將依設定日期發布此Alert
          </div>
        </div>
        <div class="flex-grow-1 flex-basis-0 my-n2 d-flex">
          <SimpleSelectWithSearchInput
            class="mr-5"
            buttonPlaceholder="請選擇年份"
            buttonWidth="148px"
            modalWidth="148px"
            modalBodyHeight="208px"
            :options="options.year"
            :selectedValue.sync="yearOfStart"
          ></SimpleSelectWithSearchInput>
          <SimpleSelectWithSearchInput
            class="mr-5"
            buttonPlaceholder="請選擇月份"
            buttonWidth="148px"
            modalWidth="148px"
            modalBodyHeight="208px"
            :options="options.month"
            :selectedValue.sync="monthOfStart"
          ></SimpleSelectWithSearchInput>
          <SimpleSelectWithSearchInput
            class="mr-5"
            buttonPlaceholder="請選擇日期"
            buttonWidth="148px"
            modalWidth="148px"
            modalBodyHeight="208px"
            :options="options.date"
            :selectedValue.sync="dateOfStart"
          ></SimpleSelectWithSearchInput>
        </div>
      </div>
      <!-- 設定結束日期 -->
      <div class="form-item py-5 d-flex">
        <div class="w-240px mr-5">
          <h4>設定結束日期</h4>
          <div class="mt-3 h5 ink-02-medium--text">
            前台將依設定日期關閉此Alert
          </div>
        </div>
        <div class="flex-grow-1 flex-basis-0 d-flex my-n2">
          <SimpleSelectWithSearchInput
            class="mr-5"
            buttonPlaceholder="請選擇年份"
            buttonWidth="148px"
            modalWidth="148px"
            modalBodyHeight="208px"
            :options="options.year"
            :selectedValue.sync="yearOfClose"
          ></SimpleSelectWithSearchInput>
          <SimpleSelectWithSearchInput
            class="mr-5"
            buttonPlaceholder="請選擇月份"
            buttonWidth="148px"
            modalWidth="148px"
            modalBodyHeight="208px"
            :options="options.month"
            :selectedValue.sync="monthOfClose"
          ></SimpleSelectWithSearchInput>
          <SimpleSelectWithSearchInput
            class="mr-5"
            buttonPlaceholder="請選擇日期"
            buttonWidth="148px"
            modalWidth="148px"
            modalBodyHeight="208px"
            :options="options.date"
            :selectedValue.sync="dateOfClose"
          ></SimpleSelectWithSearchInput>
        </div>
      </div>
    </div>
    <div class="page-actions">
      <v-spacer></v-spacer>
      <button class="btn mr-5" @click="cancelHandler">
        取消
      </button>
      <button class="btn btn-primary" @click="saveHandler">儲存</button>
    </div>
  </div>
</template>

<script>
import Breadscrumbs from '@/components/Breadscrumbs.vue';
import TextEditor from '@/components/TextEditor.vue';
import SimpleSelectWithSearchInput from '@/components/Selection/SimpleSelectWithSearchInput.vue';

export default {
  components: {
    Breadscrumbs,
    TextEditor,
    SimpleSelectWithSearchInput,
  },
  data: () => ({
    yearOfStart: '',
    monthOfStart: '',
    dateOfStart: '',
    yearOfClose: '',
    monthOfClose: '',
    dateOfClose: '',
    options: {
      year: [...Array(100).keys()].map((i) => `${i + 1991}`),
      month: [...Array(12).keys()].map((i) => `${i + 1} `),
      date: [...Array(31).keys()].map((i) => `${i + 1} `),
    },
  }),
  methods: {
    cancelHandler() {
      this.$router.push('/alert-info');
    },
    saveHandler() {
      this.$router.push('/alert-info');
    },
  },
};
</script>

<style></style>
